import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useToggleState } from '@cian/react-utils';
import { Input } from '../Input';
import { InputAdornmentButton } from '../../../inputAdornment';
import { IconFunctionalShow16, IconFunctionalHide16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export var PasswordInput = /*#__PURE__*/React.forwardRef(function PasswordInput(props, ref) {
  var _useToggleState = useToggleState(false),
    visible = _useToggleState.state,
    toggleVisible = _useToggleState.toggle;
  var ToggleVisibleIcon = visible ? IconFunctionalHide16 : IconFunctionalShow16;
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    type: visible ? 'text' : 'password',
    rightAdornment: /*#__PURE__*/_jsx(InputAdornmentButton, {
      onClick: toggleVisible,
      "aria-label": visible ? 'Скрыть пароль' : 'Показать пароль',
      children: /*#__PURE__*/_jsx(ToggleVisibleIcon, {
        color: "icon-secondary-default"
      })
    })
  }));
});